import { match, Right } from "@insightfulscience/shared-utils/either";

import routes, { followToReturlUrl } from "../routes";
import { errorToLeft, globalGqlErrors } from "../utils/gql";

export const EINVALID_EMAIL_OR_PASSWORD = "errors.EINVALID_EMAIL_OR_PASSWORD";

const login = ({ email, password }) => ({ authService }) =>
	authService
		.signIn(email, password)
		.then(
			match(errorCode => {
				throw errorCode;
			}, followToReturlUrl({ fallback: routes.myAccount })),
		)
		.then(Right)
		.catch(errorToLeft(globalGqlErrors));

export default login;
